import axios from 'axios';
/**
 * Created by alvinoktavianus on 6/29/17.
 */

import { ACTIVATE_TRIAL } from './constants';

export function startTrial(featureData, params) {
  return axios.put(ACTIVATE_TRIAL, featureData, {
    params,
    withCredentials: true,
  });
}
